export default __webpack_public_path__ + "static/residential-hero-a93af62f47e09761060c32833a54b1bb.jpg";